import { getType, vCompare } from './utils';
import { IS_TALION } from './Globals';
import UA from './ua';
export function extractVersionFrom(name, ua) {
    var _a;
    if (ua === void 0) { ua = navigator.userAgent; }
    var reg = new RegExp("".concat(name, "( |/)([0-9.]*)"), 'i');
    var info = ua.toLowerCase().match(reg);
    var version = info ? (_a = info.pop()) === null || _a === void 0 ? void 0 : _a.split('.').slice(0, 3).join('.') : '';
    return version;
}
export var FRODO_UA_PATTERN = 'com\\.douban\\.frodo(\\.[test|hap])?';
export var REXXAR_UA_PATTERN = 'rexxar';
export function getFrodoVersion(ua) {
    if (ua === void 0) { ua = navigator.userAgent; }
    return typeof DEV !== 'undefined' && !DEV.INAPP && !IS_TALION
        ? extractVersionFrom(FRODO_UA_PATTERN, ua) || DEV.VERSION
        : extractVersionFrom(FRODO_UA_PATTERN, ua);
}
export function getRexxarVersion(ua) {
    if (ua === void 0) { ua = navigator.userAgent; }
    return extractVersionFrom(REXXAR_UA_PATTERN, ua);
}
var FRODO_VERSION = getFrodoVersion();
var REXXAR_VERSION = getRexxarVersion();
var IOS_VERSION = UA.isIOS() ? UA.getParser().getOS().version : '';
// v == cur
var versionIs = function (v, cur) {
    if (getType(v) !== 'String') {
        throw new Error('Version value expected a string');
    }
    return vCompare(v, cur || '999') === 0;
};
// v <= cur
var versionSince = function (v, cur) {
    if (getType(v) !== 'String') {
        throw new Error('Version value expected a string');
    }
    return vCompare(v, cur || '999') !== 1;
};
var frdVersion = {
    __str__: FRODO_VERSION,
};
var rxrVersion = {
    __str__: REXXAR_VERSION,
};
var iosVersion = {
    __str__: IOS_VERSION,
};
[frdVersion, rxrVersion, iosVersion].forEach(function (obj) {
    obj.getStr = function () { return obj.__str__; };
    obj.is = function (v) { return versionIs(v, obj.__str__); };
    obj.since = function (v) { return versionSince(v, obj.__str__); };
});
export { frdVersion, rxrVersion, iosVersion };
//# sourceMappingURL=version.js.map